/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupBase,
  UnifiedClassSignupBaseOptional,
  UnifiedClassSignupBaseMetaI,
  UnifiedClassSignupBaseTrackedI,
} from "./unified-class-signup-base";
import {
  UnifiedClassSignupBaseTracked,
  UnifiedClassSignupBaseMeta,
} from "./unified-class-signup-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassWlResultRef,
  UnifiedClassWlResultRefOptional,
  UnifiedClassWlResultRefMetaI,
  UnifiedClassWlResultRefTrackedI,
} from "./unified-class-wl-result-ref";
import {
  UnifiedClassWlResultRefTracked,
  UnifiedClassWlResultRefMeta,
} from "./unified-class-wl-result-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithPersonRef,
  WithPersonRefOptional,
  WithPersonRefMetaI,
  WithPersonRefTrackedI,
} from "./with-person-ref";
import { WithPersonRefTracked, WithPersonRefMeta } from "./with-person-ref";

/**
 *
 * @export
 * @interface UnifiedClassSignupFull
 */
export interface UnifiedClassSignupFullOptional extends UnifiedClassSignupBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSignupFull
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof UnifiedClassSignupFull
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSignupFull
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  sequence?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassSignupFull
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof UnifiedClassSignupFull
   */
  instanceId?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {UnifiedClassWlResultRef}
   * @memberof UnifiedClassSignupFull
   */
  wlResult?: UnifiedClassWlResultRefOptional;
}

export interface UnifiedClassSignupFull
  extends
    UnifiedClassSignupFullOptional,
    UnifiedClassSignupBase,
    UnifiedClassSignupRef,
    WithPersonRef {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSignupFull
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof UnifiedClassSignupFull
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSignupFull
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  sequence?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassSignupFull
   */
  personId: PersonRef;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof UnifiedClassSignupFull
   */
  instanceId?: UnifiedClassInstanceRef;
  /**
   *
   * @type {UnifiedClassWlResultRef}
   * @memberof UnifiedClassSignupFull
   */
  wlResult?: UnifiedClassWlResultRef;
}

export interface UnifiedClassSignupFullTrackedI extends UnifiedClassSignupBaseOptional {
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSignupFull
   */
  signupDatetime?: Date;
  signupDatetimeIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof UnifiedClassSignupFull
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof UnifiedClassSignupFull
   */
  signupNote?: string;
  signupNoteIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof UnifiedClassSignupFull
   */
  sequence?: number;
  sequenceIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof UnifiedClassSignupFull
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof UnifiedClassSignupFull
   */
  instanceId?: UnifiedClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassWlResultRef}
   * @memberof UnifiedClassSignupFull
   */
  wlResult?: UnifiedClassWlResultRefTrackedI;
  wlResultIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassSignupFull",
  function (model: UnifiedClassSignupFull) {
    if (typeof model.signupDatetime == "string")
      model.signupDatetime = new Date(model.signupDatetime);
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatesinstanceId = transformDatesMap.get(
      "UnifiedClassInstanceRef",
    );
    if (transformDatesinstanceId && model.instanceId) {
      transformDatesinstanceId(model.instanceId);
    }
    const transformDateswlResult = transformDatesMap.get(
      "UnifiedClassWlResultRef",
    );
    if (transformDateswlResult && model.wlResult) {
      transformDateswlResult(model.wlResult);
    }
  },
);

export type UnifiedClassSignupFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  signupDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  signupNote: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sequence: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  wlResult: PropertyMeta<UnifiedClassWlResultRefMetaI>;
}>;

export var UnifiedClassSignupFullMeta: UnifiedClassSignupFullMetaI =
  {} as UnifiedClassSignupFullMetaI;
UnifiedClassSignupFullMeta = typeMeta("UnifiedClassSignupFull", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupDatetime: propertyMeta(
    "signupDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  signupNote: propertyMeta(
    "signupNote",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sequence: propertyMeta("sequence", false, false, false, MetaTypesBase.number),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  wlResult: propertyMeta(
    "wlResult",
    false,
    false,
    false,
    UnifiedClassWlResultRefMeta,
  ),
});

const metaI = UnifiedClassSignupFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSignupRefMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassSignupRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSignupBaseMeta]);
  metaI.price.inheritedFrom = UnifiedClassSignupBaseMeta.price;
  metaI.signupDatetime.inheritedFrom =
    UnifiedClassSignupBaseMeta.signupDatetime;
  metaI.signupType.inheritedFrom = UnifiedClassSignupBaseMeta.signupType;
  metaI.signupNote.inheritedFrom = UnifiedClassSignupBaseMeta.signupNote;
  metaI.sequence.inheritedFrom = UnifiedClassSignupBaseMeta.sequence;
  metaI.interfaces = metaI.interfaces.concat([WithPersonRefMeta]);
  metaI.personId.inheritedFrom = WithPersonRefMeta.personId;
});

export class UnifiedClassSignupFullTracked
  extends UnifiedClassSignupBaseTracked
  implements UnifiedClassSignupFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupDatetime__I?: Date = undefined;
  signupDatetimeIsSet: boolean = false;
  set signupDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.signupDatetime__I = v;
      this.signupDatetimeIsSet = true;
    } else {
      this.signupDatetime__I = v || undefined;
      this.signupDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupDatetime() {
    return this.signupDatetime__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  signupNote__I?: string = undefined;
  signupNoteIsSet: boolean = false;
  set signupNote(v: undefined | string) {
    if (v !== undefined) {
      this.signupNote__I = v;
      this.signupNoteIsSet = true;
    } else {
      this.signupNote__I = v || undefined;
      this.signupNoteIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupNote() {
    return this.signupNote__I;
  }
  sequence__I?: number = undefined;
  sequenceIsSet: boolean = false;
  set sequence(v: undefined | number) {
    if (v !== undefined) {
      this.sequence__I = v;
      this.sequenceIsSet = true;
    } else {
      this.sequence__I = v || undefined;
      this.sequenceIsSet = false;
    }
    this.changeTracker = true;
  }
  get sequence() {
    return this.sequence__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  instanceId__I?: UnifiedClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  wlResult__I?: UnifiedClassWlResultRefTracked = undefined;
  wlResultIsSet: boolean = false;
  set wlResult(v: undefined | UnifiedClassWlResultRefTracked) {
    if (v !== undefined) {
      this.wlResult__I = v;
      this.wlResultIsSet = true;
    } else {
      this.wlResult__I = v || undefined;
      this.wlResultIsSet = false;
    }
    this.changeTracker = true;
  }
  get wlResult() {
    return this.wlResult__I;
  }
  constructor(
    config?: UnifiedClassSignupFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.instanceId?.setIds();

    this.wlResult?.setIds();
  }
  assignFrom(
    config: UnifiedClassSignupFullOptional,
    options?: AssignOptions,
  ): UnifiedClassSignupFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.signupDatetime &&
      this.signupDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.signupDatetime = config.signupDatetime;
      if (optionsRequired.unassign) this.signupDatetimeIsSet = false;
      else this.signupDatetimeIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (
      config.signupNote &&
      this.signupNoteApplyFilter(optionsRequired.filter)
    ) {
      this.signupNote = config.signupNote;
      if (optionsRequired.unassign) this.signupNoteIsSet = false;
      else this.signupNoteIsSet = true;
    }
    if (config.sequence && this.sequenceApplyFilter(optionsRequired.filter)) {
      this.sequence = config.sequence;
      if (optionsRequired.unassign) this.sequenceIsSet = false;
      else this.sequenceIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new UnifiedClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.wlResult && this.wlResultApplyFilter(optionsRequired.filter)) {
      this.wlResult = new UnifiedClassWlResultRefTracked(
        config.wlResult,
        options,
      );
      if (optionsRequired.unassign) this.wlResultIsSet = false;
      else this.wlResultIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassSignupFullTrackedI {
    const cloned = {} as UnifiedClassSignupFullTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupDatetimeIsSetDeep() &&
      this.signupDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupDatetimeIsSet = true;
      cloned.signupDatetime = this.signupDatetime;
    } else {
      //cloned.signupDatetimeIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    if (
      this.signupNoteIsSetDeep() &&
      this.signupNoteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupNoteIsSet = true;
      cloned.signupNote = this.signupNote;
    } else {
      //cloned.signupNoteIsSet = false
    }
    if (
      this.sequenceIsSetDeep() &&
      this.sequenceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sequenceIsSet = true;
      cloned.sequence = this.sequence;
    } else {
      //cloned.sequenceIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.wlResultIsSetDeep() &&
      this.wlResultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.wlResultIsSet = true;
      cloned.wlResult = this.wlResult?.removeUnset(filter);
    } else {
      //cloned.wlResultIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassSignupFullTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupDatetimeApplyFilter(filter))
      this.signupDatetimeIsSet = false;

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    if (!this.signupNoteApplyFilter(filter)) this.signupNoteIsSet = false;

    if (!this.sequenceApplyFilter(filter)) this.sequenceIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.wlResultApplyFilter(filter)) this.wlResultIsSet = false;
    this.wlResult?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.assignId,
      UnifiedClassSignupFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.price,
      UnifiedClassSignupFullMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.signupDatetime,
      UnifiedClassSignupFullMeta,
      this.signupDatetime,
      this,
    );
  }
  signupDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupDatetimeIsSet && this.signupDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.signupType,
      UnifiedClassSignupFullMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  signupNoteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.signupNote,
      UnifiedClassSignupFullMeta,
      this.signupNote,
      this,
    );
  }
  signupNoteIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupNoteIsSet && this.signupNoteApplyFilter(filter)) return true;

    return false;
  }
  sequenceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.sequence,
      UnifiedClassSignupFullMeta,
      this.sequence,
      this,
    );
  }
  sequenceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sequenceIsSet && this.sequenceApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.personId,
      UnifiedClassSignupFullMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.instanceId,
      UnifiedClassSignupFullMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  wlResultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassSignupFullMeta.wlResult,
      UnifiedClassSignupFullMeta,
      this.wlResult,
      this,
    );
  }
  wlResultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.wlResultIsSet && this.wlResultApplyFilter(filter)) return true;
    return this.wlResult?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupDatetimeIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    if (this.signupNoteIsSetDeep(filter)) return true;
    if (this.sequenceIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.wlResultIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
